import React from "react";
import styled from "styled-components";

import BpsRecord from "../../../interfaces/BpsRecord";
import LineChart from "../../d3/Bps/LineChart";
import StackedAreaChart from "../../d3/Bps/StackedAreaChart";

interface Props {
  branch: string,
  records: BpsRecord[],
  selectedRegion: string | undefined,
  boldTitle: string,
  lightTitle: string,
  isStacked: boolean,
}

const Wrapper = styled.div`
  color: white;
  display: flex;
  flex-direction: column;

  .bps-chart__header {
    display: flex;
    flex-direction: row;
    font-family: Mapfre-Light;
    font-size: 1rem;
    justify-content: space-between;
  }

  .bps-chart__header-title {
    width: 40%;
    font-family: Mapfre-Light;

    &.bold {
      font-family: Mapfre-Bold;
    }
  }

  .bps-chart__header-branch {
    font-family: Mapfre-Bold;
    text-transform: uppercase;
  }

  .bps-chart {
    margin-top: 3em;
    margin-bottom: 3em;
  }
`;

const BpsEvolutionChart = ({ branch, records, selectedRegion, boldTitle, lightTitle, isStacked }: Props) => {
  return (
    <Wrapper className='bps-chart__wrapper'>
      <div className='bps-chart__header'>
        <div className='bps-chart__header-title'>
          <span className='bps-chart__header-title bold'>{ boldTitle }</span>
          { lightTitle }
        </div>
        <div className='bps-chart__header-branch'>
          { branch }
        </div>
      </div>
      <div className='bps-chart'>
        { isStacked ?
          <StackedAreaChart
            bpsRecords={ records }
            chartWidth={ 340 }
            chartHeight={ 340 }
            selectedSeries={ selectedRegion }
          /> :
          <LineChart
            bpsRecords={ records }
            chartWidth={ 340 }
            chartHeight={ 340 }
            selectedSeries={ selectedRegion }
          />
        }
      </div>
    </Wrapper>
  )
};

export default BpsEvolutionChart;
